module.exports = __webpack_public_path__ + "static/media/delivery-eatBeach0.3bbd3564.png";